import { render, staticRenderFns } from "./DesktopCarousel.vue?vue&type=template&id=2aa418c3&"
import script from "./DesktopCarousel.vue?vue&type=script&lang=js&"
export * from "./DesktopCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DesktopCarousel.vue?vue&type=style&index=0&id=2aa418c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports